import { createContext, useContext, useEffect, useState } from "react";

const CurrencyCtx = createContext(null);
const KEY = "peppa_currency";

// Static FX rates (USD as base). Update in backend env later if needed.
const RATES = {
    USD: { rate: 1, symbol: "$", code: "USD" },
    UGX: { rate: 3800, symbol: "USh ", code: "UGX" },
};

export function CurrencyProvider({ children }) {
    const [currency, setCurrency] = useState(() => localStorage.getItem(KEY) || "USD");

    useEffect(() => {
        localStorage.setItem(KEY, currency);
    }, [currency]);

    function convert(usdAmount) {
        const r = RATES[currency] || RATES.USD;
        return usdAmount * r.rate;
    }

    function format(usdAmount) {
        const r = RATES[currency] || RATES.USD;
        const v = usdAmount * r.rate;
        if (r.code === "UGX") {
            return `${r.symbol}${Math.round(v).toLocaleString()}`;
        }
        return new Intl.NumberFormat("en-US", { style: "currency", currency: r.code }).format(v);
    }

    return (
        <CurrencyCtx.Provider value={{ currency, setCurrency, convert, format, available: Object.keys(RATES) }}>
            {children}
        </CurrencyCtx.Provider>
    );
}

export function useCurrency() {
    return useContext(CurrencyCtx);
}
